import React from "react";
import AdminPanelLayout from "../../../components/AdminPanel/AdminPanelLayout/AdminPanelLayout";
import TrainingAGroupComp from "../../../components/AdminPanel/TrainingAGroup/TrainingAGroupComp";
import BoxShadow from "../../../shared/BoxShadow/BoxShadow";
import LiveDataAaystNotifiedUsers from "../../../components/AdminPanel/User/LiveDataAnalystNotifiedUsers/LiveDataAaystNotifiedUsers";

const LiveDataAnalystUsers = () => {
  return (
    <AdminPanelLayout>
        <LiveDataAaystNotifiedUsers />
    </AdminPanelLayout>
  );
};

export default LiveDataAnalystUsers;
